import { useEffect } from "react";
import { useLocation } from "react-router";
import { isPrerenderUserAgent } from "../util/PrerenderUtil";

// HubSpot tracking command types
type HubSpotCommand = ['setPath', string] | ['trackPageView'];

// Augment Window interface to include HubSpot tracker
declare global {
  interface Window {
    _hsq?: HubSpotCommand[];
  }
}

const tracker: HubSpotCommand[] = window._hsq = window._hsq || [];

/**
 * Hook to track page views in HubSpot analytics.
 * Automatically tracks route changes and sends page view events to HubSpot.
 *
 * @example
 * function App() {
 *   useHubSpotTracking();
 *   return <Routes>...</Routes>;
 * }
 */
const useHubSpotTracking = (): void => {
  const location = useLocation();

  useEffect(() => {
    if (isPrerenderUserAgent()) return; // a prerender snapshot is not a page view
    const path = location.pathname + location.search;
    tracker.push(['setPath', path]);
    tracker.push(['trackPageView']);
  }, [location]);
};

export default useHubSpotTracking;
